export default {
	is: {
		serviceHeader: 'Almenn afhending - engin viðbótarþjónusta',
		serviceText: 'Sending fer í afhendingarferli. Afgreiðslutími 2-3 virkir dagar',
		serviceCode: '0',
		amount: '0.00',
	},
	en: {
		serviceHeader: 'Default processing',
		serviceText: 'Shipment will get default process. 2-3 work days',
		serviceCode: '0',
		amount: '0.00',
	},
};
